import request from '@/utils/request'

// 发送密码重置验证码
export function sendPasswordResetCode(emailOrUsername) {
  return request({
    url: '/password/send-reset-code',
    method: 'post',
    data: {
      email_or_username: emailOrUsername
    }
  })
}

// 验证密码重置验证码
export function verifyPasswordResetCode(emailOrUsername, code) {
  return request({
    url: '/password/verify-reset-code',
    method: 'post',
    data: {
      email_or_username: emailOrUsername,
      code: code
    }
  })
}

// 重置密码
export function resetPassword(emailOrUsername, code, newPassword, confirmPassword) {
  return request({
    url: '/password/reset',
    method: 'post',
    data: {
      email_or_username: emailOrUsername,
      code: code,
      new_password: newPassword,
      confirm_password: confirmPassword
    }
  })
}
